import React from 'react';
import { useDropzone } from 'react-dropzone';
import { Box, Typography } from '@mui/material';
import { uploadType } from '../../Constants';

const maxFileSize = 20000000;

interface Props {
  onDrop: (acceptedFiles: File[]) => void;
  files: File[];
  filePreviews: string[];
  fileTypeId: number;
}

const FileDropzone: React.FC<Props> = ({
  onDrop,
  files,
  filePreviews,
  fileTypeId,
}) => {
  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: {
      'image/png': ['.png'],
      'image/jpg': ['.jpg'],
      'image/jpeg': ['.jpeg'],
      'image/webp': ['.webp'],
      'audio/mpeg': ['.mp3'],
    },
    maxSize: maxFileSize,
  });

  const showBackground =
    filePreviews.length > 0 &&
    (fileTypeId === uploadType.image ||
      fileTypeId === uploadType.poster ||
      fileTypeId === uploadType.blog);

  const styleProp = {
    padding: '3px',
    border: '1px dashed #888888',
    width: '100%',
    height: '50px',
    backgroundImage: showBackground ? `url(${filePreviews[0]})` : 'none',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center center',
    cursor: 'pointer',
  };

  return (
    <Box display={'flex'} justifyContent={'flex-start'} alignItems={'center'}>
      <Box
        sx={{
          width: '140px',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <div {...getRootProps()} style={styleProp}>
          <input {...getInputProps()} />
          {files.length === 0 && (
            <Typography variant='body1' textAlign={'center'}>
              Drag file or click to browse
            </Typography>
          )}
        </div>
      </Box>
    </Box>
  );
};

export default FileDropzone;
